module.exports = __webpack_public_path__ + "img/pages.71eafb21.svg";